export const ListItemStyles = () => {
  return {
    styleOverrides: {
      root: {
        backgroundColor: "var(--Schemes-Surface-Container-Low)",
        borderRadius: "12px",
        padding: "0px 16px",
        minHeight: "80px",
        "&:not(:last-child)": {
          marginBottom: "8px",
        },
        "& .MuiListItemText-primary":{
            color: "var(--Schemes-On-Surface)",
            fontSize: "16px",
            fontStyle:" normal",
            fontWeight: 500,
            lineHeight: "24px", /* 150% */
            letterSpacing: "0.15px",

          },
        "& .MuiListItemText-secondary":{
            color: "var(--Schemes-On-Surface)",
            fontSize: "14px",
            fontStyle:" normal",
            fontWeight: 400,
            lineHeight: "20px", /* 150% */
             letterSpacing: "0.25px",

          }
        }

    }
  }
}